import React from "react";
import { useHistory } from "react-router-dom";
import mainBg from "@public/img/main-bg.svg";
import "@/styles/auth.css";

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  const history = useHistory();

  return (
    <div role="main" className="auth-page">
      <img src={mainBg} alt="" className="auth-page__bg" />
      <div className="auth-page__wrap">
        <div className="auth-page__inner">
          <div className="auth-page__content">{children}</div>
          <button
            type="button"
            className="auth-page__back"
            onClick={() => history.replace("/")}
          >
            بازگشت به صفحه اصلی
          </button>
        </div>
      </div>
    </div>
  );
}
